import { h } from 'preact'

import MonthLink from '../MonthLink'
import YearLink from '../YearLink'
import LinkWrapper from '../link-wrapper'

import styles from './index.module.scss'

const MonthList = ({ href, title, entries = [], ...rest }) => (
  <article className={styles['a-month-list']} {...rest}>
    <h1 className={styles['a-month-list__title']}>
      <YearLink href={href}>{title}</YearLink>
    </h1>

    <ol className={styles['a-month-list__entries']}>
      {entries.map((entry, idx) => (
        <MonthListEntry
          {...entry}
          key={entry.key || idx}
        />
      ))}
    </ol>
  </article>
)

const MonthListEntry = ({ href, title, label }) => (
  <li className={styles['a-month-list__entry']}>
    <MonthLink>
      {href ? (<LinkWrapper href={href} title={title}>{label}</LinkWrapper>) : label}
    </MonthLink>
  </li>
)

export default MonthList
